import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState:any = {};

const supportedPoolsSlice = createSlice({
  name: 'supportedPools',
  initialState,
  reducers: {
    setSupportedPools(state,action:PayloadAction<any>){
      state.supportedPools = action.payload;
    }
  },

});

// Reducer
export default supportedPoolsSlice.reducer;

// Actions
export const {setSupportedPools} = supportedPoolsSlice.actions;